import React from 'react';

import ParagraphCta from '../../Paragraph/Cta';

const CtaBlock = ({ entity }) => {
  // Ensure we render the Yellow variant
  entity = entity.setIn(['field_background_color', 0, 'value'], 'yellow');

  return (
    <div>
      <ParagraphCta entity={entity} />
    </div>
  );
};

export default CtaBlock;
